module.exports = __webpack_public_path__ + "static/webstorm4-64f8f36be02da6d060e0dd6ace3b5160.png";